/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AiReviewUsageBasicInfo} from '../models/AiReviewUsageBasicInfo';
import type {AiReviewUsageDetailedInfo} from '../models/AiReviewUsageDetailedInfo';
import type {Error} from '../models/Error';

export interface GetAiReviewUsageDetail$Request {
    changeRequestId: number;
}

export interface GetAiReviewUsageDetail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAiReviewUsageDetailRequest = createAction<PayloadData<void, GetAiReviewUsageDetail$Request>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_AI_REVIEW_USAGE_DETAIL__REQUEST');
export const getAiReviewUsageDetailSuccess = createAction<PayloadData<Array<AiReviewUsageDetailedInfo>, GetAiReviewUsageDetail$Request>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_AI_REVIEW_USAGE_DETAIL__SUCCESS');
export const getAiReviewUsageDetailFailure = createAction<PayloadData<Error, GetAiReviewUsageDetail$Request, true>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_AI_REVIEW_USAGE_DETAIL__FAILURE');

export const getAiReviewUsageDetailActions = [
    getAiReviewUsageDetailRequest,
    getAiReviewUsageDetailSuccess,
    getAiReviewUsageDetailFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAiReviewUsageDetail = (meta: GetAiReviewUsageDetail$Request, config?: GetAiReviewUsageDetail$Config) => {
    return {
        CALL_API: {
            types: getAiReviewUsageDetailActions,
            method: ApiMethods.GET,
            endpoint: `/ai/change-requests/${meta.changeRequestId}/ai-usage`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAllAiReviewUsageBasicInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllAiReviewUsageBasicInfoRequest = createAction<PayloadData<void>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_ALL_AI_REVIEW_USAGE_BASIC_INFO__REQUEST');
export const getAllAiReviewUsageBasicInfoSuccess = createAction<PayloadData<Array<AiReviewUsageBasicInfo>>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_ALL_AI_REVIEW_USAGE_BASIC_INFO__SUCCESS');
export const getAllAiReviewUsageBasicInfoFailure = createAction<PayloadData<Error, void, true>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_ALL_AI_REVIEW_USAGE_BASIC_INFO__FAILURE');

export const getAllAiReviewUsageBasicInfoActions = [
    getAllAiReviewUsageBasicInfoRequest,
    getAllAiReviewUsageBasicInfoSuccess,
    getAllAiReviewUsageBasicInfoFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllAiReviewUsageBasicInfo = (config?: GetAllAiReviewUsageBasicInfo$Config) => {
    return {
        CALL_API: {
            types: getAllAiReviewUsageBasicInfoActions,
            method: ApiMethods.GET,
            endpoint: `/ai/change-requests/ai-usage`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetCreateAiReviewUsageCount$Request {
    changeRequestId: number;
}

export interface GetCreateAiReviewUsageCount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCreateAiReviewUsageCountRequest = createAction<PayloadData<void, GetCreateAiReviewUsageCount$Request>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_CREATE_AI_REVIEW_USAGE_COUNT__REQUEST');
export const getCreateAiReviewUsageCountSuccess = createAction<PayloadData<number, GetCreateAiReviewUsageCount$Request>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_CREATE_AI_REVIEW_USAGE_COUNT__SUCCESS');
export const getCreateAiReviewUsageCountFailure = createAction<PayloadData<Error, GetCreateAiReviewUsageCount$Request, true>>('CHANGE_REQUEST_AI_USAGE_CONTROLLER__GET_CREATE_AI_REVIEW_USAGE_COUNT__FAILURE');

export const getCreateAiReviewUsageCountActions = [
    getCreateAiReviewUsageCountRequest,
    getCreateAiReviewUsageCountSuccess,
    getCreateAiReviewUsageCountFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCreateAiReviewUsageCount = (meta: GetCreateAiReviewUsageCount$Request, config?: GetCreateAiReviewUsageCount$Config) => {
    return {
        CALL_API: {
            types: getCreateAiReviewUsageCountActions,
            method: ApiMethods.GET,
            endpoint: `/ai/change-requests/${meta.changeRequestId}/ai-usage/run-count`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

